import { useMemo } from "../libraries";
import { dynamicTimeZone } from "./timeZone";
export const useUserRoleAndSection = () => {
  const role = useMemo(() => localStorage.getItem('role'), []);
  const isSection = localStorage.getItem('isSection');
  return { role, isSection };
};

export const getFormatedDateMonthName = (date) => {
// <<<<<<< HEAD
//   return new Date(date).toLocaleDateString(
//     "en-GB", // This sets the date format to day/month/year
//     {
//       month: "short",
//       day: "2-digit",
//       year: "numeric",
//       timeZone: dynamicTimeZone(), // Specifies the Bangkok timezone
//     }
//   );
// };



    return new Date(date).toLocaleDateString(
      "en-GB",
      {
        month: "short",
        day: "2-digit",
        year: "numeric",
        timeZone: dynamicTimeZone(),
      }
    );
  };
export const populateDynamicContent = (template, dynamicData) => {
  if (!template || !dynamicData) return template;
  return template.replace(/{{\s*websiteName\s*}}/g, dynamicData);
};